// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"4ec32def","592":"11980a1e","606":"9f201397","911":"79aaba71"}[chunkId] + ".chunk.css";
};